import { cn } from "../dashboard/ui";
const TONE_CLASS = {
    default: "text-fg",
    good: "text-status-healthy",
    warn: "text-status-warning",
    bad: "text-status-error",
    muted: "text-fg-muted",
};
/** 상세 패널·요약용 작은 지표 카드. 숫자는 tabular-nums. */
export function MetricCard({ label, value, unit, hint, icon: Icon, tone = "default", sub, className }) {
    return (<div className={cn("min-w-0 rounded-lg border border-border bg-bg-elevated px-3 py-2", className)} title={hint ?? label} role="group" aria-label={`${label}: ${value}${unit ? ` ${unit}` : ""}`}>
      <div className="flex items-center gap-1 text-[11px] text-fg-subtle">
        {Icon && <Icon aria-hidden size={12} className="shrink-0"/>}
        <span className="truncate">{label}</span>
      </div>
      <div className={cn("mt-0.5 flex items-baseline gap-1 tabular", TONE_CLASS[tone])}>
        <span className="truncate text-lg font-semibold leading-tight">{value}</span>
        {unit && <span className="shrink-0 text-[11px] text-fg-subtle">{unit}</span>}
      </div>
      {sub && <div className="mt-0.5 truncate text-[11px] text-fg-muted">{sub}</div>}
    </div>);
}
